import SignaturePad from "react-signature-canvas";

const SignatureField = ({
  id,
  item,
  index,
  refKey,
  formData,
  signatureRefs,
  draftSignatures,
  setDraftSignatures,
}) => {
  return (
    <div key={index} className="mb-6">
      <label className="block text-sm font-medium mb-2 text-gray-900">
        {item.question} {item.required && <span className="text-red-500">*</span>}
      </label>

      <div className="flex flex-col items-center gap-5">
        {formData[index].answer && id ? (
          <img
            src={formData[index].answer}
            alt="Signature"
            style={{
              maxWidth: "100%",
              height: "auto",
              padding: "5px",
              objectFit: "contain",
            }}
          />
        ) : (
          <>
            <SignaturePad
              ref={(ref) => {
                signatureRefs.current[refKey] = ref;
                if (ref && draftSignatures[refKey]) {
                  ref.fromDataURL(draftSignatures[refKey]);
                }
              }}
              onEnd={() => {
                const signature = signatureRefs.current[refKey].toDataURL();
                setDraftSignatures((prev) => ({
                  ...prev,
                  [refKey]: signature,
                }));
              }}
              canvasProps={{
                className:
                  "w-full h-[200px] bg-gray-50 border-2 border-dashed border-gray-200 rounded-md",
              }}
            />
            <button
              type="button"
              className="px-4 py-2 bg-gray-100 text-gray-800 text-sm rounded-md border border-gray-300 hover:bg-gray-200 transition"
              onClick={() => {
                signatureRefs.current[refKey].clear();
                setDraftSignatures((prev) => {
                  const newDrafts = { ...prev };
                  delete newDrafts[refKey];
                  return newDrafts;
                });
              }}
            >
              Clear Signature
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default SignatureField;
